<template>
  <ContentSection>
    <!-- TITLE & TEXT -->
    <HeadingAndText :heading="data.heading" :text="data.text" />

    <div
      class="
        relative mb-6 flex h-[80vh] max-h-160 min-h-120 w-full
        lg:mb-10
        xl:h-[50vh]
      "
    >
      <iframe
        v-if="data.url"
        :title="data.url"
        class="size-full"
        :src="iframeSrc"
        frameborder="0"
      />
    </div>
  </ContentSection>
</template>

<script setup lang="ts">
import type { MainComponentsIframeFragment } from '#gql'

const props = defineProps<{ data: Enforce<MainComponentsIframeFragment> }>()

const iframeSrc = ref<string>('')

onMounted(() => {
  iframeSrc.value = props.data.url
})
</script>
